
import React from 'react';
import FeederPageHeader from '@/components/feeder/FeederPageHeader';
import { useAutoPublish } from '@/hooks/useAutoPublish';
import { AutoPublishControls } from '@/components/feeder/AutoPublishControls';
import FeederInterviewsList from '@/components/feeder/FeederInterviewsList';
import { useFeederPublishing } from '@/components/feeder/useFeederPublishing';
import { useInterviewDialogs } from '@/components/feeder/useInterviewDialogs';
import { usePublishInterval } from '@/components/feeder/usePublishInterval';
import { useFeederInterviewsData } from '@/components/feeder/useFeederInterviewsData';
import EditorialLayout from '@/components/editorial/EditorialLayout';

const FeederPage: React.FC = () => {
  // Get feeder interviews data
  const { feederInterviews, isLoading, error, refetch } = useFeederInterviewsData();
  
  // Handle publishing
  const { publishingId, handlePublish } = useFeederPublishing();
  
  // Handle interview dialogs
  const {
    selectedInterview,
    isViewDialogOpen,
    isEditDialogOpen,
    handleViewInterview,
    handleEditInterview,
    handleCloseViewDialog,
    handleCloseEditDialog,
    handleSendToFeeder
  } = useInterviewDialogs();
  
  // Handle publish interval settings
  const {
    publishInterval,
    selectedPreset,
    customInterval,
    showCustomInterval,
    handleIntervalChange,
    handleCustomIntervalChange,
    applyCustomInterval
  } = usePublishInterval();
  
  // Use auto-publish hook
  const { isAutoPublish, toggleAutoPublish, resetAutoPublishTimer, timeUntilNextPublish } = useAutoPublish({
    interviews: feederInterviews,
    onPublish: handlePublish,
    publishInterval
  });
  
  return (
    <EditorialLayout>
      <div className="max-w-6xl mx-auto py-4 px-4">
        <FeederPageHeader />

        {/* Auto-publish controls */}
        <AutoPublishControls
          isAutoPublish={isAutoPublish}
          publishInterval={publishInterval}
          selectedPreset={selectedPreset}
          customInterval={customInterval}
          showCustomInterval={showCustomInterval}
          toggleAutoPublish={toggleAutoPublish}
          handleIntervalChange={handleIntervalChange}
          handleCustomIntervalChange={handleCustomIntervalChange}
          applyCustomInterval={applyCustomInterval}
          timeUntilNextPublish={timeUntilNextPublish}
        />

        {/* Feeder interviews list */}
        <FeederInterviewsList
          interviews={feederInterviews || []}
          isLoading={isLoading}
          error={error}
          onViewInterview={handleViewInterview}
          onEditInterview={handleEditInterview}
          onPublish={handlePublish}
          onSendToFeeder={handleSendToFeeder}
          publishingId={publishingId}
          selectedInterview={selectedInterview}
          isViewDialogOpen={isViewDialogOpen}
          isEditDialogOpen={isEditDialogOpen}
          handleCloseViewDialog={handleCloseViewDialog}
          handleCloseEditDialog={handleCloseEditDialog}
        />
      </div>
    </EditorialLayout>
  );
};

export default FeederPage;
